'use strict';

// Get Lists
var getRenderList = require('./all-lists');
var Dropdown = require('./Dropdown');
var getUserData = require('../models/user-urls');

function getRenderDropdowns(depsArg) {
	var renderList = getRenderList.getRenderList(depsArg);
	var userData = getUserData.getUserData();

	return {
		renderManageDropdown: function render(config, deps) {
			return (new Dropdown({
				listContainer: renderList.renderManageList(config, deps),
				className: 'manage-dropdown',
				linkClassName: 'manage-link',
				label: 'Manage'
			})).render(config, deps);
		},

		renderLanguageDropdown: function render(config, deps) {
			return (new Dropdown({
				listContainer: renderList.renderLanguageList(config, deps),
				className: 'language-dropdown',
				label: deps.languages[config.locale] || ''
			})).render(config, deps);
		},

		renderProfileDropdown: function render(config, deps) {
			return (new Dropdown({
				listContainer: renderList.renderUserList(config, deps),
				className: 'user-dropdown',
				label: userData.getUserName(config)
			})).render(config, deps);
		},

		renderCompanyDropdown: function render(config, deps) {
			var user = config.UserInfo;
			var memberships = config.memberships;
			var _ = deps.underscore;
			var result = '';
			var currentMembership;
			var currentCompany;

			if (user && memberships && memberships.length > 0) {
				currentMembership = _.find(memberships, function(membership) {
					return membership.company.uuid === user.company_id;
				});

				try {
					currentCompany = currentMembership.company.name;
				} catch (e) {
					currentCompany = null;
				}

				return (new Dropdown({
					listContainer: renderList.renderCompanyList(config, deps),
					className: 'company-dropdown',
					label: currentCompany
				})).render(config, deps);
			}

			return result;
		},

		renderCurrencyDropdown: function render(config, deps) {
			return (new Dropdown({
				listContainer: renderList.renderCurrencyList(config, deps),
				className: 'currency-dropdown',
				label: config.defaultCurrency
			})).render(config, deps);
		}
	};
}

module.exports = {
	getRenderDropdowns: getRenderDropdowns
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/all-dropdowns.js
// module id = 34
// module chunks = 0